export enum ExpressedPreferenceProperties {
  Commented = 'commented',
  MediaId = 'mediaId',
  ExpressedType = 'expressedType',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  ProfileId = 'profileId',
}
export enum ExpressedPreferenceMetaProperties {}
